//Wed Jan 01 2025 00:00:00 GMT+0530 (India Standard Time) to YYYY-MM-DD
export const convertDate = (date) => {
  const newDate = new Date(date);
  const year = newDate.getFullYear();
  const month = ("0" + (newDate.getMonth() + 1)).slice(-2);
  const day = ("0" + newDate.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
};

//Wed Jan 01 2025 00:00:00 GMT+0530 (India Standard Time) to DD-MM-YYYY
export const convertDateToDateMonthYear = (date) => {
  const newDate = new Date(date);
  const year = newDate.getFullYear();
  const month = ("0" + (newDate.getMonth() + 1)).slice(-2);
  const day = ("0" + newDate.getDate()).slice(-2);
  return `${day}-${month}-${year}`;
};

//YYYY-MM-DDT00:00:00.000Z to MM/DD/YYYY
export const convertYearMonthDateToMonthDateYear = (date) => {
  const newDate = new Date(date);
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  const formattedDate = `${month < 10 ? "0" + month : month}/${
    day < 10 ? "0" + day : day
  }/${year}`;
  console.log("formattedDate", formattedDate);
  return formattedDate;
};
//DD-MM-YYYY to MM/DD/YYYY
export const convertDateFormat = (dateStr) => {
  const [day, month, year] = dateStr.split('-');
  return `${month}/${day}/${year}`;
};


export function convertToLocalTime(isoString, options = {}) {
  const date = new Date(isoString);

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    ...options,
  });
}

export function formatDateTime(isoString, options = {}) {
  const date = new Date(isoString);

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",   
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    ...options, 
  });
}
//convert 2025-10-02T00:39:28.000Z to DD-MM-YYYY
export const convertTimeStampToDate = (date) => {
  const newDate = new Date(date);

  const day = ("0" + newDate.getDate()).slice(-2);
  const month = ("0" + (newDate.getMonth() + 1)).slice(-2);
  const year = newDate.getFullYear().toString();

  return `${day}-${month}-${year}`;
};

